module.exports = __webpack_public_path__ + "img/layout_02_hover.43ed0e0a.svg";